import { render, staticRenderFns } from "./SixthPage.vue?vue&type=template&id=39801df4&scoped=true&"
import script from "./SixthPage.vue?vue&type=script&lang=js&"
export * from "./SixthPage.vue?vue&type=script&lang=js&"
import style0 from "./SixthPage.vue?vue&type=style&index=0&id=39801df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39801df4",
  null
  
)

export default component.exports